import React from 'react';
import { ServicesContext } from '~/services';
import { BannerModal, ListBanners } from '~/components/Admin';

export function Banner() {
    const servicesContext = React.useContext(ServicesContext);
    const [showCreate, setShowCreate] = React.useState(false);

    return !servicesContext.user.isBannerAdmin() ? null : (
        <>
            <div className="row mb-2">
                <div className="col-12 text-end">
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => setShowCreate(true)}
                    >
                        <i className="fa-solid fa-plus" /> Add Banner
                    </button>
                    <BannerModal show={showCreate} setShow={setShowCreate} />
                </div>
            </div>
            <ListBanners />
        </>
    );
}
